import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { CustomImage } from "checkout-experience/components/common/custom-image";
import {
  brandSection,
  checkout,
  header,
  logoDesktop,
  logoMobile,
} from "checkout-experience/components/header/header.css";
import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";
import {
  CheckoutIntentPayload,
  useJWTPayload,
} from "checkout-query-client/hooks/use-jwt-payload";

type HeaderProps = {
  hideCheckoutInfo?: boolean;
};

export const Header = ({ hideCheckoutInfo }: HeaderProps) => {
  const { t } = useTranslation(["combined"]);
  const {
    merchantSettings,
    experienceType,
    checkoutSessionToken = "",
  } = useChexContext();

  const { data: checkoutIntentPayload } =
    useJWTPayload<CheckoutIntentPayload>(checkoutSessionToken);
  const { mor } = checkoutIntentPayload ?? {};

  if (!merchantSettings?.pageHeader || !merchantSettings?.pageHeader.enabled) {
    return null;
  }

  const returnToCartUrl =
    merchantSettings?.pageHeader?.returnToCartUrl.includes("?")
      ? `${merchantSettings?.pageHeader?.returnToCartUrl}${mor ? "&reference=" + mor : ""}`
      : `${merchantSettings?.pageHeader?.returnToCartUrl}${mor ? "?reference=" + mor : ""}`;

  return (
    <>
      <header className={header}>
        <div className={brandSection}>
          {merchantSettings.pageHeader.merchantLogoSettings
            ?.merchantLogoEnabled && (
            <>
              <CustomImage
                className={logoDesktop}
                src={
                  merchantSettings.pageHeader.merchantLogoSettings
                    ?.merchantLogoUrl
                }
                alt={t("merchantLogo") || ""}
              />
              <CustomImage
                className={logoMobile}
                src={
                  merchantSettings.pageHeader.merchantLogoSettings
                    ?.merchantLogoUrlMobile ||
                  merchantSettings.pageHeader.merchantLogoSettings
                    ?.merchantLogoUrl
                }
                alt={t("merchantLogo") || ""}
              />
            </>
          )}
          {!hideCheckoutInfo && merchantSettings?.pageHeader?.checkoutTitle && (
            <div className={checkout}>
              <Text styleVariant="heading1" colorVariant="primaryText">
                {t("checkout")}
              </Text>
            </div>
          )}
        </div>
        <div>
          {!hideCheckoutInfo &&
          experienceType === "hpp" &&
          merchantSettings?.pageHeader?.returnToCart ? (
            <a href={returnToCartUrl} aria-labelledby="returnToCart">
              <Text
                styleVariant="body"
                colorVariant="interactive"
                id="returnToCart"
              >
                {t("return-to-cart")}
              </Text>
            </a>
          ) : null}
        </div>
      </header>
    </>
  );
};
